import { DevPlatformAdapter } from './adapters/DevPlatformAdapter'
import { NoopPlatformAdapter } from './adapters/NoopPlatformAdapter'
import { TelegramPlatformAdapter } from './adapters/TelegramPlatformAdapter'
import { VkPlatformAdapter } from './adapters/VkPlatformAdapter'
import type { IPlatformAdapter } from './ports/IPlatformAdapter'
import type { PlatformKind } from './ports/types'

export interface CreatePlatformAdapterOptions {
  startParam?: string | null
  /** Dev only: real Mini App initData / VK launch query for auth/mini-app. */
  payload?: string | null
}

export function createPlatformAdapter(
  kind: PlatformKind,
  options: CreatePlatformAdapterOptions = {},
): IPlatformAdapter {
  switch (kind) {
    case 'telegram':
      return new TelegramPlatformAdapter()
    case 'vk':
      return new VkPlatformAdapter()
    case 'dev':
      return new DevPlatformAdapter({
        startParam: options.startParam,
        payload: options.payload,
      })
    case 'none':
      return new NoopPlatformAdapter()
    default: {
      const _exhaustive: never = kind
      void _exhaustive
      return new NoopPlatformAdapter()
    }
  }
}
